import React, { useState } from 'react';
import { IconArrowRightLong } from '../ui-kit/icons';
import moment from 'moment';
import { Modal, Button, ListGroup } from '../ui-kit';
import { connect } from 'react-redux';
import Sound from 'react-sound';
import alert from './alert.mp3';
import { selectors as arSchedulesSelectors } from '../../state/modules/availability-requirement-schedules';
import ScheduleWarning from '../schedule/ScheduleWarning';

const StateChangedPopupItem = ({ group, availabilityRequirement, previousState, currentState, timestamp }) => (
  <ListGroup.Item>
    <h2>{group.name}</h2>
    <h3>
      <small>{moment(timestamp).format('LTS')}</small>{' '}
      <ScheduleWarning
        inline
        size={'large'}
        availabilityRequirement={availabilityRequirement}
        availabilityRequirementState={previousState}
      />{' '}
      <IconArrowRightLong />{' '}
      <ScheduleWarning
        inline
        size={'large'}
        availabilityRequirement={availabilityRequirement}
        availabilityRequirementState={currentState}
      />
    </h3>
  </ListGroup.Item>
);

const StateChangedPopup = props => {
  const [dismissedChangeHashes, setDismissedChangeHashes] = useState([]);

  const significantChanges = Object.values(props.significantChanges).filter(
    c => !dismissedChangeHashes.includes(c.hash)
  );

  // hashes of the dismissed changes to the list of dismissals
  const dismiss = () => setDismissedChangeHashes([...dismissedChangeHashes, ...significantChanges.map(c => c.hash)]);

  if (significantChanges.length === 0) return null;

  return (
    <>
      <Modal size="lg" show={true}>
        <Modal.Body>
          <ListGroup>
            {significantChanges.map(change => (
              <StateChangedPopupItem {...change} key={change.hash} />
            ))}
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={dismiss}>{I18n.t('close')}</Button>
        </Modal.Footer>
      </Modal>
      <Sound url={alert} playStatus={Sound.status.PLAYING} loop={true} />
    </>
  );
};

const mapStateToProps = state => ({
  significantChanges: arSchedulesSelectors.selectSignificantChanges(state)
});

export { StateChangedPopup };

export default connect(mapStateToProps)(StateChangedPopup);
